import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const OdtFileImage = (t0)=>{
    const $ = c(9);
    const { width, height } = t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.4064 5H35.5L48.9999 18.8V45.0115C48.9999 48.3218 46.1974 50.9999 42.7453 50.9999H19.2666C15.8025 50.9999 13 48.3218 13 45.0115V10.9884C12.9999 7.6781 15.9423 5 19.4064 5Z",
            fill: "#E2E6EB"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M35.5289 14.384V5L48.9999 18.8L40.0192 18.8C35.9779 18.8 35.3418 15.856 35.5289 14.384Z",
            fill: "#BAC6D1"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M7 33C7 30.7909 8.79086 29 11 29H37C39.2091 29 41 30.7909 41 33V43C41 45.2091 39.2091 47 37 47H11C8.79086 47 7 45.2091 7 43V33Z",
            fill: "#1159E5"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M29.6183 34.921V33.2729H37.3832V34.921H34.4886V42.7275H32.5128V34.921H29.6183Z",
            fill: "white"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M24.3035 42.7275H20.952V33.2729H24.3312C25.2822 33.2729 26.1009 33.4622 26.7872 33.8407C27.4735 34.2162 28.0013 34.7563 28.3706 35.4611C28.743 36.1659 28.9292 37.0092 28.9292 37.9909C28.9292 38.9758 28.743 39.8221 28.3706 40.53C28.0013 41.2379 27.4704 41.7811 26.778 42.1596C26.0886 42.5382 25.2638 42.7275 24.3035 42.7275ZM22.9509 41.0147H24.2204C24.8113 41.0147 25.3084 40.9101 25.7116 40.7008C26.1178 40.4885 26.4225 40.1607 26.6256 39.7175C26.8318 39.2712 26.9349 38.6957 26.9349 37.9909C26.9349 37.2923 26.8318 36.7214 26.6256 36.2782C26.4225 35.8351 26.1193 35.5088 25.7162 35.2995C25.313 35.0903 24.816 34.9856 24.2251 34.9856H22.9509V41.0147Z",
            fill: "white"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M19.4712 38.0002C19.4712 39.0312 19.2758 39.9083 18.8849 40.6316C18.4972 41.3548 17.9678 41.9073 17.2969 42.2889C16.629 42.6674 15.8781 42.8567 15.044 42.8567C14.2038 42.8567 13.4498 42.6659 12.782 42.2843C12.1141 41.9026 11.5863 41.3502 11.1985 40.627C10.8107 39.9037 10.6168 39.0281 10.6168 38.0002C10.6168 36.9692 10.8107 36.092 11.1985 35.3688C11.5863 34.6455 12.1141 34.0946 12.782 33.7161C13.4498 33.3345 14.2038 33.1436 15.044 33.1436C15.8781 33.1436 16.629 33.3345 17.2969 33.7161C17.9678 34.0946 18.4972 34.6455 18.8849 35.3688C19.2758 36.092 19.4712 36.9692 19.4712 38.0002ZM17.4446 38.0002C17.4446 37.3323 17.3446 36.7691 17.1445 36.3105C16.9476 35.852 16.669 35.5042 16.3089 35.2672C15.9489 35.0302 15.5272 34.9118 15.044 34.9118C14.5608 34.9118 14.1392 35.0302 13.7791 35.2672C13.419 35.5042 13.139 35.852 12.9389 36.3105C12.742 36.7691 12.6435 37.3323 12.6435 38.0002C12.6435 38.668 12.742 39.2312 12.9389 39.6898C13.139 40.1484 13.419 40.4962 13.7791 40.7331C14.1392 40.9701 14.5608 41.0886 15.044 41.0886C15.5272 41.0886 15.9489 40.9701 16.3089 40.7331C16.669 40.4962 16.9476 40.1484 17.1445 39.6898C17.3446 39.2312 17.4446 38.668 17.4446 38.0002Z",
            fill: "white"
        });
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] !== height || $[7] !== width) {
        t7 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 56 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6
            ]
        });
        $[6] = height;
        $[7] = width;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
};
export { OdtFileImage };
